import styles from './Card.module.css'

interface CardProps {
  kicker?: string
  title?: string
  body?: string
  meta?: string
  elevation?: 'sm' | 'md' | 'lg'
  className?: string
  children?: React.ReactNode
  onClick?: () => void
}

export function Card({ kicker, title, body, meta, elevation, className = '', children, onClick }: CardProps) {
  return (
    <div
      className={`${styles.card}${elevation ? ` ${styles[`elev-${elevation}`]}` : ''} ${className}`}
      onClick={onClick}
    >
      {kicker && <div className={styles['card-kicker']}>{kicker}</div>}
      {title && <div className={styles['card-title']}>{title}</div>}
      {children && <div>{children}</div>}
      {body && <p className={styles['card-body']}>{body}</p>}
      {meta && <div className={styles['card-meta']}>{meta}</div>}
    </div>
  )
}
